import * as React from 'react';
import { Vega, VisualizationSpec } from 'react-vega';

import { SystemMessage } from 'bones/design-system/components/notifications/SystemMessage';
import { useDidValueChange } from 'bones/utils/hooks/useDidValueChange';

export interface ChartProps {
  errorText?: string;
  onValidateChart?: (valid: boolean) => void;
  showActions?: boolean;
  spec: VisualizationSpec;
  testId?: string;
}

export const Chart: React.VFC<ChartProps> = ({
  errorText,
  onValidateChart,
  showActions = true,
  spec,
  testId,
}) => {
  const [hasValidSpec, setHasValidSpec] = React.useState<boolean | undefined>(
    undefined
  );
  const didSpecChange = useDidValueChange(spec);

  React.useEffect(() => {
    if (didSpecChange) {
      setHasValidSpec(undefined);
    }
  }, [setHasValidSpec, didSpecChange]);

  if (hasValidSpec === false && errorText) {
    return (
      <div className="vb-chart" data-testid={testId}>
        <SystemMessage text={errorText} variant="alert" />
      </div>
    );
  }

  return (
    <div className="vb-chart" data-testid={testId}>
      {hasValidSpec ? (
        <Vega actions={showActions ? { editor: false } : false} spec={spec} />
      ) : null}
      <Vega
        actions={false}
        onError={() => {
          setHasValidSpec(false);
          onValidateChart?.(false);
        }}
        onNewView={() => {
          setHasValidSpec(true);
          onValidateChart?.(true);
        }}
        spec={spec}
        style={{ display: 'none' }}
      />
    </div>
  );
};
